import Head from "next/head";
import Footer from "pages/components/Footer";
import StartHumming from "pages/components/StartHumming";
import Topbar from "pages/components/Topbar";
import React from "react";
import { ExtendedNextPage } from "types/pages";

import FAQLayout from "./components/faq";
import styles from "./styles.module.scss";

const FAQ: ExtendedNextPage = () => {
  return (
    <div className={styles.container}>
      <Head>
        <title>Home page</title>
        <meta name="about" content="Humming home's about page" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <FAQLayout />
      <StartHumming fillColor="white" />
    </div>
  );
};

FAQ.getLayout = (page) => {
  return (
    <div>
      <Topbar withHeader />
      {page}
      <Footer />
    </div>
  );
};

export default FAQ;
